import { Routes } from '@angular/router';
import { permisoGuard } from '../core/auth/permiso.guard';
import { Permiso } from '../core/auth/permisos';

/** Sección a la que pertenecen estas pantallas (encabezado de la bandeja). */
const SECCION = 'Rabia (RAB)';

/**
 * Sección de Rabia. Es el primer caso del sistema en que **un solo diagnóstico
 * emite dos documentos**: la inmunofluorescencia directa (IHIMV-RT-21-RAB),
 * que sale en horas, y la prueba biológica (IHIMV-RT-21-RAB 1), que se corre
 * después.
 *
 * Las dos comparten la página —la técnica y el rótulo de la columna de
 * resultado los decide la pantalla, que va por el `data` de la ruta—, y sus
 * bandejas listan las mismas recepciones, porque la de prueba biológica toma
 * prestados los diagnósticos de la de IFD.
 */
export const rabiaRoutes: Routes = [
  {
    path: 'rabia/ifd',
    canActivate: [permisoGuard],
    loadComponent: () =>
      import('../shared/analisis/bandeja-diagnostico/bandeja-diagnostico.page').then(
        (m) => m.BandejaDiagnosticoPage,
      ),
    title: 'SiLabVet | Rabia — Inmunofluorescencia Directa',
    data: {
      pantalla: 'RABIA',
      breadcrumb: SECCION,
      titulo: 'Rabia — Inmunofluorescencia Directa',
      permiso: Permiso.RABIA_VER,
    },
  },
  {
    path: 'rabia/ifd/:id/trabajar',
    canActivate: [permisoGuard],
    data: {
      pantalla: 'RABIA',
      permiso: [Permiso.RABIA_RESULTADOS, Permiso.RABIA_VER],
    },
    loadComponent: () =>
      import('./pages/rabia-resultados/rabia-resultados.page').then(
        (m) => m.RabiaResultadosPage,
      ),
    title: 'SiLabVet | Informe de resultado — Rabia (IFD)',
  },
  {
    path: 'rabia/prueba-biologica',
    canActivate: [permisoGuard],
    loadComponent: () =>
      import('../shared/analisis/bandeja-diagnostico/bandeja-diagnostico.page').then(
        (m) => m.BandejaDiagnosticoPage,
      ),
    title: 'SiLabVet | Rabia — Prueba Biológica',
    data: {
      pantalla: 'RABIA_PRUEBA_BIOLOGICA',
      breadcrumb: SECCION,
      titulo: 'Rabia — Prueba Biológica',
      permiso: Permiso.RABIA_PRUEBA_BIOLOGICA_VER,
    },
  },
  {
    // Reusa la página de IFD: la pantalla decide la técnica y el rótulo.
    path: 'rabia/prueba-biologica/:id/trabajar',
    canActivate: [permisoGuard],
    data: {
      pantalla: 'RABIA_PRUEBA_BIOLOGICA',
      permiso: [
        Permiso.RABIA_PRUEBA_BIOLOGICA_RESULTADOS,
        Permiso.RABIA_PRUEBA_BIOLOGICA_VER,
      ],
    },
    loadComponent: () =>
      import('./pages/rabia-resultados/rabia-resultados.page').then(
        (m) => m.RabiaResultadosPage,
      ),
    title: 'SiLabVet | Informe de resultado — Rabia (Prueba Biológica)',
  },
];
